<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 text-black"
>
  <div class="flex flex-col">
    <div
      class="bg-white flex flex-col gap-[1.5rem] px-[2.5rem] py-[1.5rem]"
      [class.rounded-lg]="false"
    >
      <app-button
        [text]="'components.modal.close' | transloco"
        [icon]="'close'"
        [iconSize]="'1.3125rem'"
        (buttonClick)="closeModal.emit()"
        class="w-fit self-end"
      ></app-button>

      <h4>{{title()}}</h4>
      @if(text()) {
      <p [innerHTML]="text() | safeHtml"></p>
      }
      <div class="flex flex-col gap-2">
        @if(inputTitle()) {
        <p class="!font-bold">{{inputTitle()}}</p>
        }
        <input
          type="text"
          class="border border-vinciGrey-300 rounded-lg px-4 py-2 w-full"
          required
          [placeholder]="placeholder()"
          [value]="inputValue()"
          (input)="inputValue.set($event.target.value)"
        />
      </div>
      <div class="flex items-center gap-2 w-full md:w-1/4 md:ml-auto">
        <app-button
          [text]="buttonText()"
          [variant]="'secondary'"
          [icon]="'thumb-up'"
          [disabled]="inputValue().length > 0 ? false : true"
          (buttonClick)="completeModal.emit(inputValue())"
          class="flex-1"
        ></app-button>
      </div>
    </div>
  </div>
</div>
